import * as Yup from "yup";

export const paymentValidationSchema = Yup.object().shape({
  paymentMethod: Yup.string().required('Payment method is required'),
  // Card validation
  cardNumber: Yup.string().when('paymentMethod', {
    is: 'card',
    then: () => Yup.string()
      .required('Card number is required')
      .matches(/^\d{16}$/, 'Card number must be 16 digits'),
  }),
  expiryDate: Yup.string().when('paymentMethod', {
    is: 'card',
    then: () => Yup.string()
      .required('Expiry date is required')
      .matches(/^(0[1-9]|1[0-2])\/([0-9]{2})$/, 'Expiry date must be in MM/YY format'),
  }),
  cvv: Yup.string().when('paymentMethod', {
    is: 'card',
    then: () => Yup.string()
      .required('CVV is required')
      .matches(/^\d{3,4}$/, 'CVV must be 3 or 4 digits'),
  }),
  // PayPal validation
  paypalEmail: Yup.string().when('paymentMethod', {
    is: 'paypal',
    then: () => Yup.string()
      .required('PayPal email is required')
      .email('Invalid email format'),
  }),
  // Crypto validation
  cryptoAmount: Yup.string().when('paymentMethod', {
    is: 'crypto',
    then: () => Yup.string()
      .required('Amount is required')
      .matches(/^\d+(\.\d{1,8})?$/, 'Invalid crypto amount'),
  }),
  selectedCurrency: Yup.string().when('paymentMethod', {
    is: 'crypto',
    then: () => Yup.string().required('Please select a cryptocurrency'),
  }),
});

export const paymentInitialValues = {
  paymentMethod: 'card',
  cardNumber: '',
  expiryDate: '',
  cvv: '',
  paypalEmail: '',
  cryptoAmount: '',
  selectedCurrency: '',
};
